/**
 * Bedrock token pricing (USD per 1K tokens, us-east-1 on-demand).
 *
 * Bake-in source of truth; refresh with
 * `data-platform/bedrock_chat/scripts/refresh_pricing.py` (which pulls the
 * AWS Price List API and rewrites this file). Prices update at most a few
 * times per year, so a live API call per request isn't worth the latency.
 */

export type ModelPricing = {
  inputPer1K: number;
  outputPer1K: number;
};

// PRICING_TABLE_START — keys are Bedrock inference profile IDs (cross-region
// `us.anthropic.*` and base IDs); values are USD per 1K tokens. Update via
// the refresh script.
export const PRICING: Record<string, ModelPricing> = {
  "us.anthropic.claude-opus-4-7": { inputPer1K: 0.015, outputPer1K: 0.075 },
  "us.anthropic.claude-opus-4-6-v1": { inputPer1K: 0.015, outputPer1K: 0.075 },
  "us.anthropic.claude-sonnet-4-6": { inputPer1K: 0.003, outputPer1K: 0.015 },
  "us.anthropic.claude-haiku-4-5-20251001": { inputPer1K: 0.001, outputPer1K: 0.005 },
};
// PRICING_TABLE_END

function rateFor(modelId: string | null | undefined): ModelPricing | null {
  if (!modelId) return null;
  return PRICING[modelId] ?? null;
}

export function turnCost(
  modelId: string | null | undefined,
  tokensIn: number,
  tokensOut: number,
): number | null {
  const r = rateFor(modelId);
  if (!r) return null;
  return (tokensIn * r.inputPer1K + tokensOut * r.outputPer1K) / 1000;
}

export function formatCost(usd: number | null): string {
  if (usd == null) return "—";
  if (usd === 0) return "$0";
  if (usd < 0.01) return `$${usd.toFixed(4)}`;
  return `$${usd.toFixed(3)}`;
}
